import Fredrica from '../../assets/images/doctors/Fredrica.webp'
import Troyana from '../../assets/images/doctors/Troyana Smalls.webp'
import Sydney from '../../assets/images/doctors/Sydney Calloway.jpeg'
import Reginald from '../../assets/images/doctors/Reginald Louis.jpg'
import Shana from '../../assets/images/doctors/Shana Campbell.jpeg'
import Dyimond from '../../assets/images/doctors/Dyimond Anderson.webp'
import Shanessa from '../../assets/images/doctors/Shanessa Crook.jpeg'
import Ivan from '../../assets/images/doctors/Ivan Estrada.webp'
import Danielle from '../../assets/images/doctors/Danielle Miller.webp'
import Ellayah from '../../assets/images/doctors/Ellayah.jpeg'
import Tiana from '../../assets/images/doctors/Tiana Britton.jpeg'


const DoctorsData = [
    {
        id : 1,
        name: "Fredrica Dennis",
        image: Fredrica,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "Virtual",
                time: "10-5",
                hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5']
            },
            {
                day: "Tuesday",
                type: "In Person",
                time: "11-6",
                hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6']
            },
            {
                day: "Wednesday",
                type: "In Person",
                time: "12-7",
                hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
            },
            {
                day: "Thursday",
                type: "In Person",
                time: "10-6",
                hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5', '5-6']
            },
            {
                day: "Friday",
                type: "Virtual",
                time: "10-3",
                hours : ['10-11', '11-12', '12-01', '1-2', '2-3']
            },
        ],
        description: "Drica holds a deep belief in the resilience and potential of each individual, recognizing that life’s challenges, transitions, and traumas can sometimes veer us off course from our authentic selves. Drica has had the privilege of supporting kids, adolescents, adults, and families across cultures to support healing, self-awareness, and empowerment. Drica has experience with Autism, ADHD, anxiety, and depression. She also supports stress management, life transitions and well-being. Drica uses a mix of play therapy, mindfulness, CBT and solution-focused therapy to create an environment for growth. She believes play, creativity and authenticity are critical in all phases of life. In her spare time, she loves writing, playing sports, and listening to music.",
    },
    {
        id : 2,
        name: "Sydney Calloway",
        image: Sydney,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "In Person",
                time: "11-7",
                hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6', '6-7']
            },
            {
                day: "Tuesday",
                type: "In Person",
                time: "9-6",
                hours : ['9-10', '10-11', '11-12','12-1','1-2', '2-3', '3-4', '4-5','5-6']
            },
            {
                day: "Wednesday",
                type: "Virtual",
                time: "8-3",
                hours : ['8-9', '9-10', '10-11','11-12','12-1', '1-2', '2-3']
            },
            {
                day: "Thursday",
                type: "In Person",
                time: "10-6",
                hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5', '5-6']
            },
            {
                day: "Friday",
                type: "Virtual",
                time: "9-12",
                hours : ['9-10', '10-11', '11-12']
            },
        ],
        description: "Sydney is a Licensed Professional Counselor (LPC) who graduated from Mercer University with an MS in Clinical Mental Health Counseling. Sydney’s work at the inpatient and outpatient levels has given her invaluable experience working with individuals from multicultural backgrounds. Sydney treats individuals with anxiety, depression, bipolar disorders, grief, postpartum, cultural, and substance abuse issues. Sydney is passionate about assisting individuals to become the best version of themselves. Sydney uses a collective modality approach of Cognitive Behavioral Therapy (CBT), Person Centered Therapy, Motivational Interviewing, and Dialectical Behavioral Therapy (DBT) to assist individuals in meeting their specific needs and goals.",
    },
    {
        id : 3,
        name: "Reginald Louis",
        image: Reginald,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "Virtual",
                time: "11-6",
                hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6']
            },
            {
                day: "Tuesday",
                type: "Virtual",
                time: "10-5",
                hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5']
            },
            {
                day: "Wednesday",
                type: "In Person",
                time: "12-7",
                hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
            },
            {
                day: "Thursday",
                type: "In Person",
                time: "12-7",
                hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
            },
            {
                day: "Friday",
                type: "In Person",
                time: "9-4",
                hours : ['9-10', '10-11', '11-12','12-1','1-2', '2-3', '3-4']
            },
            {
                day: "Saturday",
                type: "Virtual",
                time: "11-6",
                hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6']
            },
            {
                day: "Sunday",
                type: "Virtual",
                time: "11-6",
                hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6']
            },
        ],
        description: "Reginald is a LAPC who specializes in guiding individuals toward emotional and physical well-being & personal empowerment. His focus includes anxiety, depression management to include paternal postnatal depression (PPND), and personal growth. His preferred modalities are Virtual Reality Therapy (VRT), Cognitive Behavioral Therapy (CBT), Rational Emotive Behavioral Therapy (REBT), & Mindfulness. He collaborates with you to overcome obstacles. He is committed to guiding individuals to become their optimal selves. He believes that it is courageous to embark on a personalized therapeutic journey towards emotional well-being & offers a warm, empathetic space for your unique path. Whether it’s anxiety, depression, or self-discovery, he is here to listen.",
    },

    {
        id : 5,
        name: "Shanessa Crook",
        image: Shanessa,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "In Person",
                time: "1-7",
                hours: ['1-2', '2-3', '3-4', '5-6', '6-7']
            },
            // {
            //     day: "Tuesday",
            //     type: "Virtual",
            //     time: "2-6",
            //     hours: ['2-3', '3-4', '4-5', '5-6']
            // },
            {
                day: "Wednesday",
                type: "In Person",
                time: "1 PM - 7 PM",
                hours: ['1-2', '2-3', '3-4', '5-6', '6-7']
            },
            {
                day: "Thursday",
                type: "Virtual",
                time: "9-4",
                hours : ['9-10', '10-11','11-12','12-1', '1-2', '2-3','3-4']
            },
            {
                day: "Friday",
                type: "Virtual",
                time: "8-3",
                hours : ['8-9', '9-10', '10-11','11-12','12-1', '1-2', '2-3']
            },
        ],
        description: "Hi and welcome! I’m Shanessa, a Licensed Professional Counselor (LPC). Do you ever feel overwhelmed and have a hard time finding balance in your life? Are you noticing a breakdown in your relationships (family, friends, partners) but don’t know how to repair them? Do you simply need unbiased support and guidance in your life? Yes, I’m talking to you! We can work together to decrease your stressors, improve relationships with effective communication, and make healthier choices. My strengths include being genuine, consistent, building relationships, introducing effective coping skills/communication, and helping my clients work towards their goals. Give yourself grace and remember that progress is progress! I look forward to meeting and working with you!",
    },
    // {
    //     id : 6,
    //     name: "Dyimond Anderson",
    //     image: Dyimond,
    //     email: "QPS@yjcandwellness.com",
    //     availableTime: [
    //         {
    //             day: "Monday",
    //             type: "Virtual",
    //             time: "12-7",
    //             hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
    //         },
    //         {
    //             day: "Tuesday",
    //             type: "In Person",
    //             time: "12-7",
    //             hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
    //         },
    //         {
    //             day: "Wednesday",
    //             type: "In Person",
    //             time: "11-6",
    //             hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6']
    //         },
    //         {
    //             day: "Thursday",
    //             type: "In Person",
    //             time: "10-5",
    //             hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5']
    //         },
    //         {
    //             day: "Friday",
    //             type: "Virtual",
    //             time: "9-4",
    //             hours : ['9-10', '10-11','11-12','12-1', '1-2', '2-3','3-4']
    //         },
    //     ],
    //     description: "Dyimond is a bilingual (English and Spanish) Licensed Professional Counselor (LPC) and Registered Yoga Teacher (RYT-200). She believes that challenges in life are beautiful and necessary and understands that they can feel overwhelming too. Dyimond’s approach is based in scientific theory, inspired by personal experience, and creatively tailored to each person. She is also equipped to incorporate Christian faith values into sessions if individuals desire. Life can be hard, but we have the strength to overcome with grace and in freedom. Dyimond would be honored to be a part of your journey. You are worth the work. Let’s get started.",
    // },
    // {
    //     id : 7,
    //     name: "Troyana Smalls",
    //     image: Troyana,
    //     email: "QPS@yjcandwellness.com",
    //     availableTime: [
    //         {
    //             day: "Monday",
    //             type: "In Person",
    //             time: "12-7",
    //             hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
    //         },
    //         {
    //             day: "Tuesday",
    //             type: "Virtual",
    //             time: "10-5",
    //             hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5']
    //         },
    //         {
    //             day: "Wednesday",
    //             type: "In Person",
    //             time: "12-7",
    //             hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
    //         },
    //         {
    //             day: "Thursday",
    //             type: "In Person",
    //             time: "11-6",
    //             hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6']
    //         },
    //         {
    //             day: "Friday",
    //             type: "Virtual",
    //             time: "9-4",
    //             hours : ['9-10', '10-11','11-12','12-1', '1-2', '2-3','3-4']
    //         },
    //     ],
    //     description: "Troy is a Certified Anger Management Specialist with over five years of experience in the mental health field. She has a diverse background and prefers to utilize an eclectic, integrative approach to counseling by combining techniques from different theories to creatively address client issues. Her goal is to provide a safe and nonjudgmental environment for clients to effectively explore how to navigate the ebbs and flows of life. She aspires to help motivate positive change and growth in clients on their journey to optimal mental health and wellness. She looks forward to working with you!",
    // },
    {
        id : 8,
        name: "Ivan Estrada",
        image: Ivan,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Saturday",
                type: "In Person",
                time: "8-8",
                hours: ['8-9', '9-10', '10-11', '11-12', '12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7', '7-8']
            },
            {
                day: "Sunday",
                type: "In Person",
                time: "2-8",
                hours: ['2-3', '3-4', '4-5', '5-6', '6-7', '7-8']
            },
            {
                day: "Monday",
                type: "In Person",
                time: "1-8",
                hours : ['1-2', '2-3', '3-4','4-5','5-6', '6-7', '7-8']
            },
            {
                day: "Tuesday",
                type: "In Person",
                time: "1-8",
                hours : ['1-2', '2-3', '3-4','4-5','5-6', '6-7', '7-8']
            },
            // {
            //     day: "Wednesday",
            //     type: "Virtual",
            //     time: "9-4",
            //     hours : ['9-10', '10-11','11-12','12-1', '1-2', '2-3','3-4']
            // },
            // {
            //     day: "Thursday",
            //     type: "In Person",
            //     time: "12-7",
            //     hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
            // },
            // {
            //     day: "Friday",
            //     type: "Virtual",
            //     time: "10-5",
            //     hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5']
            // },
        ],
        description: "Ivan is a Licensed Associate Professional Counselor dedicated to helping clients discover their potential, overcome challenges, and build on their strengths. Ivan is particularly passionate about supporting parents in fostering closer connections with their children. He works with clients aged 5 and older and offers a welcoming, supportive environment. Fluent in Spanish, Ivan provides counseling for individuals who may face language barriers and struggle with English as their first language. If you are experiencing mental health challenges or seeking guidance through difficult times, contact Ivan today to schedule a free consultation.",
    },
    // {
    //     id : 4,
    //     name: "Shana Campbell",
    //     image: Shana,
    //     email: "QPS@yjcandwellness.com",
    //     availableTime: [
    //         {
    //             day: "Monday",
    //             type: "Virtual",
    //             time: "3-8",
    //             hours : ['3-4','4-5','5-6','6-7','7-8']
    //         },
    //         {
    //             day: "Tuesday",
    //             type: "Virtual",
    //             time: "1-6",
    //             hours : ['1-2','2-3','3-4','4-5','5-6']
    //         },
    //         {
    //             day: "Wednesday",
    //             type: "Virtual",
    //             time: "3-8",
    //             hours : ['3-4','4-5','5-6','6-7','7-8']
    //         },
    //         {
    //             day: "Thursday",
    //             type: "Virtual",
    //             time: "2-7",
    //             hours : ['2-3','3-4','4-5','5-6','6-7']
    //         },
    //         {
    //             day: "Saturday",
    //             type: "Virtual",
    //             time: "11-4",
    //             hours : ['11-12','12-1','1-2','2-3','3-4']
    //         },
    //     ],
    //     description: "Shana holds a master’s degree in Marriage and Family Therapy. She has over 6 years of clinical experience counseling individuals, couples, and groups. She enjoys working with individuals who are in life transitions by helping them navigate uncertainties and cultivate inner peace. Shana can help clients restore hope, joy, and rest. It is Shana’s hope that through collaboration, clients will become empowered to make new decisions to experience new outcomes in their lives.",
    // },

    {
        id : 5,
        name: "Danielle Miller",
        image: Danielle,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "In Person",
                time: "12-7",
                hours : ['12-1','1-2','2-3','3-4','4-5','5-6','6-7']
            },
            {
                day: "Tuesday",
                type: "In Person",
                time: "11-6",
                hours : ['11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
            {
                day: "Wednesday",
                type: "Virtual",
                time: "11-6",
                hours : ['11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
            {
                day: "Thursday",
                type: "Virtual",
                time: "10-5",
                hours : ['10-11','11-12','12-1','1-2','2-3','3-4','4-5']
            },
            {
                day: "Friday",
                type: "In Person",
                time: "9-4",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4']
            },
        ],
        description: "Dani uses an integrative approach including Person-Centered Therapy, Dialetical Behavior Therapy (DBT), Cognitive Behavioral Therapy (CBT), and attachment theory to aid clients in overcoming difficulties and growing into their most authentic selves. Dani specializes in supporting clients with anxiety, depression, grief, relationship challenges, substance use issues, and those living with HIV. Dani also enjoys working with the youth and young adults. Dani believes collaboration and a strong therapeutic alliance are vital in therapy. You are not alone. Let’s talk!",
    },

    {
        id : 6,
        name: "Ellayah Persons",
        image: Ellayah,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "In Person and Virtual",
                time: "8-7",
                hours : ['8-9','9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6','6-7']
            },
            {
                day: "Tuesday",
                type: "In Person Or Virtual",
                time: "9-6",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
        
            {
                day: "Thursday",
                type: "In Person Or Virtual",
                time: "9-6",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
            {
                day: "Friday",
                type: "Virtual",
                time: "9-6",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
        ],
        description: "Hi, I'm Ellayah Persons! I'm excited to support you on your journey toward becoming your best self. I believe everyone can benefit from a bit of guidance, and I aim to provide a compassionate, supportive space for you to explore your thoughts and emotions. I specialize in helping individuals 8 and older manage stress, navigate self-identity, cope with trauma, and address body image concerns. My goal is to empower you to create positive changes by fostering self-awareness and resilience. Whether you're transitioning into adulthood or navigating the complexities of adulting, I'm here to help you build the tools needed to handle life's challenges with clarity and strength. I look forward to working with you! ",
    },

    {
        id : 7,
        name: "Tiana Britton",
        image: Tiana,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "Virtual",
                time: "11-7",
                hours : ['11-12','12-1','1-2','2-3','3-4','4-5','5-6','6-7']
            },
            {
                day: "Tuesday",
                type: "In Person",
                time: "11-6",
                hours : ['11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
           
            {
                day: "Thursday",
                type: "In Person",
                time: "9-4",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4']
            },
            {
                day: "Friday",
                type: "Virtual",
                time: "9-6",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
            {
                day: "Saturday",
                type: "Virtual",
                time: "10-1",
                hours : ['10-11','11-12','12-1']
            }
        ],
        description: "Tiana finds working with diverse individuals highly rewarding and focuses on issues like depression, anxiety, trauma, stress, self-worth, and self-image. She uses cognitive behavioral therapy (CBT), person-centered therapy, and emotion-focused therapy (EFT) to emphasize the crucial role of emotions in daily life and relationships. Tiana is committed to creating a safe, empathetic, and genuine space for clients, fostering a strong therapeutic alliance and promoting healing. She encourages clients to take an active role in their therapeutic journey, supporting them in processing, growing, and healing at their own pace.",
    },


]

export default DoctorsData;
